{
  "$schema": "http://json.schemastore.org/package",
  "name": "verdaccio-google-oauth-ui-2",
  "version": "1.0.33",
  "keywords": [
    "authentication",
    "google",
    "login",
    "npm",
    "oauth",
    "package",
    "private",
    "registry",
    "verdaccio",
    "verdaccio-auth",
    "verdaccio-auth-plugin",
    "verdaccio-plugin"
  ],
  "homepage": "https://github.com/Bryllyant/verdaccio-google-oauth-ui-2/blob/master/README.md",
  "bugs": "https://github.com/Bryllyant/verdaccio-google-oauth-ui-2/issues",
  "repository": "github:Bryllyant/verdaccio-google-oauth-ui-2",
  "license": "MIT",
  "author": "Abraham Schilling",
  "main": "dist/server/index.js",
  "bin": "dist/cli/index.js",
  "files": [
    "dist"
  ],
  "scripts": {
    "build": "bash run build",
    "clean": "bash run clean",
    "cli:login": "bash run cli-login",
    "cli:publish": "bash run cli-publish",
    "cli:whoami": "bash run cli-whoami",
    "cli": "bash run cli",
    "copy": "bash run copy",
    "coverage": "vitest --coverage",
    "dev": "yarn update && yarn start",
    "docker": "bash run docker_",
    "fix": "yarn format && yarn typecheck",
    "format:check": "prettier --check \"**/*.{ts,js,css,scss,html,json}\"",
    "format": "prettier --write \"**/*.{ts,js,css,scss,html,json}\"",
    "prepack": "bash run clean && bash run build",
    "start": "verdaccio -c verdaccio.yaml",
    "test": "vitest --watch false",
    "typecheck": "bash run typecheck",
    "update": "yarn prepack && yarn copy",
    "watch": "nodemon --watch src --watch verdaccio.yaml --ext ts,css,yaml --exec \"yarn dev\""
  },
  "dependencies": {
    "@octokit/oauth-methods": "^2.0.4",
    "@octokit/request": "^6.2.3",
    "@verdaccio/commons-api": "^10.2.0",
    "@verdaccio/url": "11.0.0-6-next.21",
    "chalk": "^4.1.2",
    "dotenv": "^16.0.3",
    "express": "^4.18.2",
    "global-agent": "^3.0.0",
    "googleapis": "^110.0.0",
    "lodash": "^4.17.21",
    "memory-cache": "^0.2.0",
    "minimist": "^1.2.7",
    "octokit": "^2.0.13",
    "open": "^8.4.0",
    "ow": "^0.28.2",
    "query-string": "^7.1.3"
  },
  "devDependencies": {
    "@parcel/config-default": "~2.4.1",
    "@parcel/transformer-typescript-tsc": "~2.4.1",
    "@types/express": "^4.17.15",
    "@types/global-agent": "^2.1.1",
    "@types/lodash": "^4.14.191",
    "@types/memory-cache": "^0.2.2",
    "@types/minimist": "^1.2.2",
    "@types/node": "^16.18.11",
    "@types/query-string": "^6.3.0",
    "@verdaccio/types": "^10.7.0",
    "browserslist": "^4.21.4",
    "c8": "^7.12.0",
    "core-js": "^3.27.2",
    "nodemon": "^2.0.20",
    "parcel": "~2.4.1",
    "prettier": "^2.8.3",
    "process": "^0.11.10",
    "release-it": "^15.6.0",
    "timekeeper": "^2.2.0",
    "type-fest": "^2.19.0",
    "typescript": "^4.9.4",
    "verdaccio": "^5.19.1",
    "verdaccio-htpasswd": "^10.5.1",
    "vite": "^3.2.5",
    "vitest": "^0.22.1"
  },
  "peerDependencies": {
    "verdaccio": ">=5"
  },
  "engines": {
    "node": "^16"
  },
  "targets": {
    "client": {
      "source": "src/client/verdaccio-5.ts",
      "distDir": "dist/client",
      "context": "browser",
      "includeNodeModules": true
    },
    "server": {
      "source": "src/server/index.ts",
      "distDir": "dist/server",
      "context": "node",
      "outputFormat": "commonjs",
      "optimize": false,
      "isLibrary": true
    },
    "cli": {
      "source": "src/cli/index.ts",
      "distDir": "dist/cli",
      "context": "node",
      "outputFormat": "commonjs",
      "optimize": false
    }
  },
  "packageManager": "yarn@3.2.1"
}
